import React from "react";

import styles from "../HelpEnvironmentSection.module.scss";

const RecommendedEnvironmentPanel = () => {
  return (
    <div className={styles.panel}>
      <p className={styles.panelHeading}>端末・ブラウザの推奨環境</p>
      <div className={styles.card}>
        <p className={styles.cardHeading}>OS・ディスプレイ</p>
        <div className={styles.group}>
          <p className={styles.cardSubHeading}>パソコン端末</p>
          <p className={styles.text}>
            Windows11、MacOS (最新もしくは一世代前のバージョン)
            <br />
            HD(1280×720ピクセル)以上
          </p>
        </div>
        <div className={styles.group}>
          <p className={styles.cardSubHeading}>
            タブレット環境 (iPad / Chromebook)
          </p>
          <p className={styles.text}>
            iPad OS / Chrome OS (最新もしくは一世代前のバージョン)
            <br />
            8.3インチ以上
          </p>
        </div>
        <div className={styles.group}>
          <p className={styles.cardSubHeading}>
            スマートフォン (iPhone / Android)
          </p>
          <p className={styles.text}>
            iOS / Android OS (最新もしくは一世代前のバージョン)
            <br />
            4.7インチ以上
          </p>
        </div>
        <p className={styles.note}>
          ※ENAGEED GEAR for School と ENAGEED CORE
          デジタル教材の一部機能がスマートフォンでの閲覧・入力に対応しています。
        </p>
      </div>
      <div className={styles.card}>
        <p className={styles.cardHeading}>ブラウザ</p>
        <ul className={styles.list}>
          <li className={styles.item}>Google Chrome</li>
          <li className={styles.item}>Safari (Mac、iPad、iPhone のみ)</li>
          <li className={styles.item}>Microsoft Edge (Chromium)</li>
        </ul>
        <p className={styles.note}>
          ※Internet Explorerは動作対象外となります。
        </p>
      </div>
      <div className={styles.card}>
        <p className={styles.cardHeading}>ネットワーク回線</p>
        <ul className={styles.list}>
          <li className={styles.item}>ブロードバンド回線 / 4Gまたは5G回線</li>
          <li className={styles.item}>
            以下のドメインと通信が可能なこと
            <br />
            *.enageed.jp / *.enageed.net
          </li>
        </ul>
      </div>
      <div className={styles.card}>
        <p className={styles.cardHeading}>その他</p>
        <p className={styles.text}>
          教師用アカウントにはメールアドレスが必要です。
        </p>
      </div>
    </div>
  );
};

export default RecommendedEnvironmentPanel;
